"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectNodeSetImpulse = void 0;
var EdgeKeyOne_1 = require("./EdgeKeyOne");
var Edge_1 = require("./Edge");
/**
 * Impulse which indicates the result setting a node connection
 */
var ConnectNodeSetImpulse = /** @class */ (function (_super) {
    __extends(ConnectNodeSetImpulse, _super);
    function ConnectNodeSetImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "ConnectNodeSetImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        /**
         * edges removed before setting the new edge
         */
        _this.removedEdges = function (config) { return _this.push(function (registry) {
            var entity = new EdgeKeyOne_1.EdgeKeyOne();
            config(entity);
            return "removedEdges { " + entity.render(registry) + " }";
        }); };
        /**
         * edge created by this request
         */
        _this.newEdge = function (config) { return _this.push(function (registry) {
            var entity = new Edge_1.Edge();
            config(entity);
            return "newEdge { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return ConnectNodeSetImpulse;
}(Array));
exports.ConnectNodeSetImpulse = ConnectNodeSetImpulse;
//# sourceMappingURL=ConnectNodeSetImpulse.js.map